import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=6ea1bd5c&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ea1bd5c')) {
      api.createRecord('6ea1bd5c', component.options)
    } else {
      api.reload('6ea1bd5c', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=6ea1bd5c&", function () {
      api.rerender('6ea1bd5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DWlbUwBptam5/JS/comp/ImgFallback2.vue"
export default component.exports